export default __webpack_public_path__ + "static/media/uniswap.715eceb1.png";